<div>
    <h3 class="px-3 pt-4 pb-2 d-block" translate="Settings.AccountSecuritySection.Roles"><app-info-button
            labelName="Settings.AccountSecuritySection.RolesTooltip" [url]="UsersUrl"></app-info-button>
    </h3>
</div>
<div class="p-4 pt-0 px-3 pb-4 p-lg-4 pt-lg-0">
    <app-user-roles-permissions [userGuid]="selectedUserGuid"></app-user-roles-permissions>
</div>